import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { useSettings } from '../../contexts/SettingsContext';

const Footer: React.FC = () => {
  const { colors } = useTheme();
  const { appConfig } = useSettings();
  const currentYear = new Date().getFullYear();
  const appName = appConfig.system.appName || 'ATLAS SCMS';

  return (
    <footer className={`${colors.surface} border-t ${colors.border} shrink-0`}>
      <div className="px-4 py-1 leading-none">
        <div className={`text-xs ${colors.textSecondary}`}>
          © {currentYear} {appName}. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
